import InventoryIngredientsList from './InventoryIngredientsList'

export default { list: InventoryIngredientsList }
